






























































































































import { computed, defineComponent } from '@vue/composition-api'
import { useCreateLeadForm } from '@/composables/useCreateLeadForm'
import { InputSelectOption } from '@/helpers/options'
import i18n from '@/i18n'

export default defineComponent({
    name: 'CreateLeadFormStep2',
    setup() {
        const {
            state,
            referringToOwnCompany,
            referringUsers,
            assignableUsers,
            referringBranches,
            assignableBranches,
            informableUsers,
        } = useCreateLeadForm()

        const assignedToBranchName = computed<string>(() => {
            return state.referral.assignedToBranch?.name || ''
        })

        const priorityOptions = computed<InputSelectOption[]>(() => [
            {
                label: i18n.t('priority.yes').toString(),
                value: true,
            },
            {
                label: i18n.t('priority.no').toString(),
                value: false,
            },
        ])

        const followUpOptions = computed<string[]>(() => {
            const followUpTypes = []

            if (state.referral.assignedToBranch && referringToOwnCompany.value) {
                followUpTypes.push('assign')
            }

            if (state.referral.assignedToBranch) {
                followUpTypes.push(null)
                followUpTypes.push('inform')
            }

            return followUpTypes
        })

        const acceptedFileTypeOptions = computed<string[]>(() => [
            'image/*',
            '.doc',
            '.docx',
            '.xlsx',
            '.xlsm',
            '.xltx',
            '.xltm',
            '.ppt',
            '.pptx',
            '.pptjpeg',
            '.pptpng',
            '.pdf',
            '.txt',
            '.csv',
        ])

        return {
            state,
            assignedToBranchName,
            informableUsers,
            referringUsers,
            assignableUsers,
            referringBranches,
            assignableBranches,
            priorityOptions,
            followUpOptions,
            acceptedFileTypeOptions,
        }
    },
})
